<script>
import { mapActions, mapState } from "pinia/dist/pinia";
import VenueOverview from "./VenueOverview.vue";
import { useMainStore } from "@/stores/mainStore";

export default {
    name: "VenueOverviewParent",
    components: { VenueOverview },
    methods: {
        ...mapActions(useMainStore, ["getData"]),
    },
    computed: {
        ...mapState(
            useMainStore,
            [
                "allActivities",
                "allVenues",
                "categories",
                "actVenues",
                "actTermdates",
                "termDates",
                "sessions",
                "simpleActivitiesIds",
                "agesForActivities",
                "actCategories",
                "holidays",
            ],
        ),

        getSelectedVenue() {
            if (Object.values(this.allVenues).length === 0) {
                return {};
            }

            const foundVenue = Object.values(this.allVenues)?.find(
                (v) => v.venue_id === this.$route.params.venueId,
            );

            if (foundVenue === undefined) {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.$router.push({ name: "Simple" });
            }

            return foundVenue;
        },

        getSessions() {
            if (this.sessions === "") {
                return {
                    live: [],
                    expired: [],
                };
            }

            const simpleActIds = Object.values(this.allActivities)
                .filter((a) => a.flow_type === "simple")
                .map((a) => a.activity_id);

            const actIds = this.actVenues?.map((av) => av.activity_id);
            const venueSimpleSessions = this.sessions?.filter(
                (s) => (
                    s.venue_id === this.$route.params.venueId
                    && actIds.includes(s.activity_id)
                    && simpleActIds.includes(s.activity_id)
                ),
            );

            const { live, expired } = venueSimpleSessions.reduce(
                (venueSessions, session) => {
                    const sessionTerm = this.termDates.filter(
                        (el) => el.termdate_id === session.termdate_id,
                    );

                    const activity = this.allActivities.find(
                        (a) => a.activity_id === session.activity_id,
                    );

                    const end = new Date(sessionTerm[0]?.end).setHours(24, 0, 0, 0);
                    const today = new Date();

                    if (end > today.getTime()) {
                        venueSessions.live.push({ ...session, activity });
                    } else {
                        venueSessions.expired.push({ ...session, activity });
                    }

                    return venueSessions;
                },
                { live: [], expired: [] },
            );

            return {
                live,
                expired,
            };
        },
    },
    async created() {
        await this.getData();
    },
};
</script>

<template>
    <VenueOverview
        :venue="getSelectedVenue"
        :all-activities="Object.values(allActivities) || []"
        :term-dates="termDates || {}"
        :sessions="getSessions"
        :activity-ages="agesForActivities"
    />
</template>

<style scoped>

</style>
